import { useEffect, useState } from 'react';
import heart from '../assets/icon/heart.svg'
import share from '../assets/icon/share.svg'
import upi from '../assets/logo/upi.svg'
import visa from '../assets/logo/visa.svg'
import phonepe from '../assets/logo/phonepe.svg'
import mastercard from '../assets/logo/mastercard.svg'
import rupay from '../assets/logo/rupay.svg'
import google_pay from '../assets/logo/google_pay.svg'
import razorpay from '../assets/logo/razorpay.svg'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Carousel } from 'react-bootstrap';
import play_circle from '../assets/icon/play_circle.svg'
import React from 'react';
import { getDatafromDoc } from '../Firebase/firestoreGet';
import { db } from '../firebase';
import aim from '../assets/samples/anima.gif'
import Rating from '@mui/material/Rating';
import Stack from '@mui/material/Stack';
import MetaTags from '../meta';
import { encodeObj } from '../Functions';
import './Preset-item.css';

// Inline SVG icons
const HeartIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
    </svg>
);
const ShareIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="18" cy="5" r="3" /><circle cx="6" cy="12" r="3" /><circle cx="18" cy="19" r="3" />
        <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" /><line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
    </svg>
);
const ChevronDown = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="6 9 12 15 18 9" />
    </svg>
);
const CheckIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20 6 9 17 4 12" />
    </svg>
);
const TruckIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="1" y="3" width="15" height="13" /><polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
        <circle cx="5.5" cy="18.5" r="2.5" /><circle cx="18.5" cy="18.5" r="2.5" />
    </svg>
);

function Preset_item() {

    let { id } = useParams();
    const navigate = useNavigate()
    const [Data, setData] = useState()
    const location = useLocation()
    const [currH, setCurrH] = useState()
    const [fabDets, setFabDets] = useState()
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => { setIsMobile(window.innerWidth <= 768); };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const [active, setActive] = useState(0)
    const [loading, setLoading] = useState(true)

    const handleSelect = (selectedIndex) => { setActive(selectedIndex); };

    useEffect(() => {
        if (id) {
            const docref = db.collection('Presets').doc(id)
            getDatafromDoc(docref).then((data) => {
                setData(data)
                setLoading(false)
                getPresetFabric(data)
            })
        }
        else if (location && location.state && location.state["sel"]) {
            setData(location.state["sel"])
            getPresetFabric(location.state["sel"])
            setLoading(false)
        }
    }, [])

    const [QTY, setQty] = useState(1)

    const getPresetFabric = (data) => {
        try {
            var Fabric = {}
            for (let i = 0; i < data.fabrics.length; i++) {
                if (!Object.keys(Fabric).includes(data.fabrics[i].type)) {
                    Fabric[data.fabrics[i].type] = data.fabrics[i]
                }
            }
            setFabDets(Fabric)
            setCurrH(Object.keys(Fabric)[0])
        } catch (e) { console.log(e) }
    }

    const customizeRoute = () => {
        try {
            var s = ''
            Object.keys(Data.fabric).sort().forEach(element => {
                s += Data.fabric[element].fabricID
            });
            const obj = {
                customize: Data.customize,
                category: Data.category,
                discount: (Number(Data.price) * Number(Data.discount)) / 100,
                fabric: Data.fabric,
                price: Number(Data.price),
                style: Data.style,
                type: 1,
                types: Data.types,
                name: Data.name ? Data.name : `${Data.category} piece`,
                from: "presets",
                key: s,
                state: 0
            }
            navigate(`/custom/${Data.category}/select_style/customize/${encodeObj(obj)}`)
        } catch (e) { console.log(e) }
    }

    const [meta, setMeta] = useState()
    useEffect(() => {
        if (Data) {
            setMeta({
                title: `${Data["name"]} - Maviinci`,
                description: Data["des"],
                keywords: Data["des"],
                url: `/products/${Data.category}/${Data.name.replaceAll(" ", "-")}/${Data.id}`,
                image: Data.src
            })
        }
    }, [Data])

    // Accordion state
    const [openAccordion, setOpenAccordion] = useState('description');

    const deliverBy = (() => {
        const d = new Date();
        d.setDate(d.getDate() + 13);
        return d.toLocaleDateString(undefined, { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });
    })();

    const discountedPrice = Data && Data.discount && Number(Data.discount) > 0
        ? (Number(Data.price) - Number(Data.price) * (Number(Data.discount) / 100))
        : null;

    const formatPrice = (val) => Number(val).toLocaleString('en-IN', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        style: 'currency',
        currency: 'INR'
    });

    return (
        <div className="pdp">
            {meta && <MetaTags data={meta} />}

            {/* Loading */}
            {loading &&
                <div className="pdp-loading">
                    <img alt="" src={aim} onError={(e) => { e.target.src = 'https://d1fufvy4xao6k9.cloudfront.net/images/garment/loading.gif' }} />
                </div>
            }

            {!loading && Data &&
                <div className="pdp-layout">
                    {/* ===== LEFT: Gallery ===== */}
                    <div className="pdp-gallery">
                        {/* Thumbnails */}
                        <div className="pdp-thumbnails">
                            {Data && Data.single && [{ type: 1, src: Data.src }, ...Data.single].map((val, key) => (
                                <div
                                    key={key}
                                    className={`pdp-thumb ${active === key ? 'pdp-thumb--active' : ''} ${val.type === 0 ? 'pdp-thumb--video' : ''}`}
                                    onClick={() => setActive(key)}
                                >
                                    <img src={(Object.keys(val).includes("type") && val.type === 1) ? val.src : !Object.keys(val).includes("type") ? val : play_circle} alt="" />
                                </div>
                            ))}
                        </div>

                        {/* Main Carousel */}
                        <div className="pdp-main-image">
                            <Carousel activeIndex={active} variant='dark' fade
                                onSelect={handleSelect} indicators={false}>
                                {Data && Data.single && [{ type: 1, src: Data.src }, ...Data.single].map((val, key) => (
                                    <Carousel.Item key={key} interval={val.type === 0 ? 10000 : 5000}>
                                        {(Object.keys(val).includes("type") && val.type === 1) ?
                                            <img src={val.src} className="pdp-carousel-img" alt={Data.name} />
                                            : (!Object.keys(val).includes("type")) ?
                                                <img src={val} className="pdp-carousel-img" alt={Data.name} />
                                                :
                                                <video className='pdp-carousel-img' autoPlay muted playsInline loop style={{ objectFit: "contain" }}>
                                                    <source src={val.src} />
                                                </video>
                                        }
                                    </Carousel.Item>
                                ))}
                            </Carousel>
                        </div>
                    </div>

                    {/* ===== RIGHT: Product Info ===== */}
                    <div className="pdp-info">
                        {/* Breadcrumb */}
                        <div className="pdp-breadcrumb">
                            <span onClick={() => navigate('/products')}>Products</span>
                            <span className="pdp-breadcrumb-sep">/</span>
                            <span onClick={() => navigate(`/products/${Data.category}`)}>{Data.category}</span>
                            <span className="pdp-breadcrumb-sep">/</span>
                            <span className="pdp-breadcrumb-current">{Data.name}</span>
                        </div>

                        {/* Title */}
                        <h1 className="pdp-title">{Data.name}</h1>

                        {/* Rating */}
                        <div className="pdp-rating">
                            <Stack spacing={1} direction="row" alignItems="center">
                                <Rating name="half-rating-read" defaultValue={4.5} precision={0.5} readOnly size="small" sx={{ color: '#D4AF37' }} />
                                <span className="pdp-rating-text">4.5 / 5</span>
                            </Stack>
                        </div>

                        {/* Price */}
                        <div className="pdp-price-container">
                            {discountedPrice ? (
                                <>
                                    <span className="pdp-price">{formatPrice(discountedPrice)}</span>
                                    <span className="pdp-price-original">{formatPrice(Data.price)}</span>
                                    <span className="pdp-price-save">Save {Data.discount}%</span>
                                </>
                            ) : (
                                <span className="pdp-price">{formatPrice(Data.price)}</span>
                            )}
                        </div>
                        <div className="pdp-tax-note">Inclusive of all taxes</div>

                        {/* Highlights */}
                        <div className="pdp-highlights">
                            <div className="pdp-highlight">
                                <TruckIcon />
                                <span>Delivery by <strong>{deliverBy}</strong></span>
                            </div>
                            <div className="pdp-highlight pdp-highlight--green">
                                <CheckIcon />
                                <span>COD Available</span>
                            </div>
                            <div className="pdp-highlight pdp-highlight--green">
                                <CheckIcon />
                                <span>Extra 5% off on Prepaid Orders</span>
                            </div>
                            {Data.customize &&
                                <div className="pdp-highlight pdp-highlight--gold">
                                    <img src="/media/site/customize.gif" alt="Customizable" style={{width:'20px', height:'20px', borderRadius:'50%'}} />
                                    <span>Customizable</span>
                                </div>
                            }
                        </div>

                        {/* Item includes */}
                        <div className="pdp-includes">
                            <span className="pdp-includes-label">Item Includes:</span>
                            {fabDets && Object.keys(fabDets).map((val, ind) => (
                                <span key={ind} className="pdp-includes-chip">{val}</span>
                            ))}
                        </div>

                        {/* Description */}
                        {Data.des && <p className="pdp-description">{Data.des}</p>}

                        {/* Action Buttons */}
                        <div className="pdp-actions">
                            <button className="pdp-btn pdp-btn--primary"
                                onClick={() => {
                                    navigate(`/measurement/select/${encodeObj({ ...Data, ...{ item_type: 1 } })}`)
                                }}
                            >
                                Get Measured
                            </button>

                            {Data.customize &&
                                <button className="pdp-btn pdp-btn--secondary"
                                    onClick={() => customizeRoute()}
                                >
                                    Customize Now
                                </button>
                            }
                        </div>

                        {/* Share / Like */}
                        <div className="pdp-share-row">
                            <button className="pdp-icon-btn"><HeartIcon /></button>
                            <button className="pdp-icon-btn"><ShareIcon /></button>
                        </div>

                        {/* ===== Fabric Details ===== */}
                        {fabDets && currH && (
                            <div className="pdp-fabric-section">
                                <h3 className="pdp-section-title">Fabric Details</h3>

                                {/* Fabric Tabs */}
                                <div className="pdp-fabric-tabs">
                                    {Object.keys(fabDets).map((val1) => (
                                        <button
                                            key={val1}
                                            className={`pdp-fabric-tab ${currH === val1 ? 'pdp-fabric-tab--active' : ''}`}
                                            onClick={() => setCurrH(val1)}
                                        >
                                            {val1}
                                        </button>
                                    ))}
                                </div>

                                {/* Fabric Card */}
                                <div className="pdp-fabric-card">
                                    <div className="pdp-fabric-card-img">
                                        <img src={
                                            fabDets[currH]["single"] && fabDets[currH]["single"].length > 0
                                                ? fabDets[currH]["single"][0]
                                                : fabDets[currH]["src"]
                                        } alt={currH} />
                                    </div>
                                    <div className="pdp-fabric-card-info">
                                        <div className="pdp-fabric-brand">
                                            <img src={fabDets[currH].brandImg} alt="brand" />
                                            <span className="pdp-fabric-name">{fabDets[currH].name}</span>
                                        </div>
                                        <div className="pdp-fabric-specs">
                                            <div><strong>Material:</strong> {fabDets[currH].material}</div>
                                            <div><strong>Color:</strong> {fabDets[currH].color.map((c, i) => <span key={i}>{c}{i < fabDets[currH].color.length - 1 ? ', ' : ''}</span>)}</div>
                                            <div><strong>Pattern:</strong> {fabDets[currH].pattern}</div>
                                            <div><strong>Weave:</strong> {fabDets[currH].weave}</div>
                                            <div><strong>Width:</strong> {fabDets[currH].width}</div>
                                        </div>
                                        {fabDets[currH].des &&
                                            <p className="pdp-fabric-desc">{fabDets[currH].des.slice(0, 300)}</p>
                                        }
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* ===== Accordions ===== */}
                        <div className="pdp-accordions">
                            {/* Description */}
                            <div className={`pdp-accordion ${openAccordion === 'description' ? 'pdp-accordion--open' : ''}`}>
                                <button className="pdp-accordion-header" onClick={() => setOpenAccordion(openAccordion === 'description' ? null : 'description')}>
                                    <span>Description</span>
                                    <ChevronDown />
                                </button>
                                {openAccordion === 'description' && (
                                    <div className="pdp-accordion-body">
                                        <div><strong>Wash Care:</strong> Machine Wash</div>
                                        <div><strong>Occasion:</strong> Formal wear, Office wear</div>
                                        <div>Product Code: #3765874654</div>
                                        <p className="pdp-note">Note: The actual colour of the product may vary slightly due to photographic lighting sources or your device.</p>
                                    </div>
                                )}
                            </div>

                            {/* Payment */}
                            <div className={`pdp-accordion ${openAccordion === 'payment' ? 'pdp-accordion--open' : ''}`}>
                                <button className="pdp-accordion-header" onClick={() => setOpenAccordion(openAccordion === 'payment' ? null : 'payment')}>
                                    <span>Payment Options</span>
                                    <ChevronDown />
                                </button>
                                {openAccordion === 'payment' && (
                                    <div className="pdp-accordion-body">
                                        <div className="pdp-pay-logos">
                                            <img src={upi} alt="upi" />
                                            <img src={visa} alt="visa" />
                                            <img src={mastercard} alt="mastercard" />
                                            <img src={rupay} alt="rupay" />
                                            <img src={google_pay} alt="gpay" />
                                            <img src={phonepe} alt="phonepe" />
                                            <span>+10</span>
                                        </div>
                                        <div className="pdp-pay-note pdp-highlight--green">Extra 5% off on prepaid orders</div>
                                        <div className="pdp-pay-info">Pay full amount with your payment options. Powered by <img src={razorpay} alt="Razorpay" className="pdp-razorpay-logo" /></div>
                                        <div className="pdp-pay-divider">OR</div>
                                        <div className="pdp-pay-cod"><strong>Cash on Delivery</strong></div>
                                        <div className="pdp-pay-cod-note">* Only ₹500 token amount at checkout</div>
                                    </div>
                                )}
                            </div>

                            {/* Returns */}
                            <div className={`pdp-accordion ${openAccordion === 'returns' ? 'pdp-accordion--open' : ''}`}>
                                <button className="pdp-accordion-header" onClick={() => setOpenAccordion(openAccordion === 'returns' ? null : 'returns')}>
                                    <span>Alterations & Return Policy</span>
                                    <ChevronDown />
                                </button>
                                {openAccordion === 'returns' && (
                                    <div className="pdp-accordion-body">
                                        <p>Get your clothing altered free of cost* within 7 days of your order. We will pick up your cloth, get it altered for your fit. You can return the cloth within 7 days of order.</p>
                                        <div className="pdp-policy-links">
                                            <a href="/terms">Alteration Policy</a>
                                            <a href="/terms">Return & Cancellation Policy</a>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>);
}

export default Preset_item;